export const usersUrl = 'users/';
export const userUrl = (userId: string) => `users/${userId}/`;
